import React from "react";
import Layout from "antd/lib/layout/layout";

import { Typography, Space } from "antd";
import { useTranslation } from "react-i18next";

import SignInForm from "./SignInForm";

import "./index.less";
import SEO from "../../containers/helpers/SEO";
import { useContext } from "react";
import { AuthContext } from "../../contexts/auth/AuthContext";
import { Redirect } from "react-router-dom";
import BrandLogo from "../../components/brand/BrandLogo";
const { Title, Text } = Typography;

export default function Auth() {
  const { t } = useTranslation();
  const { authState } = useContext(AuthContext);

  if (authState.isAuthenticated) return <Redirect to="/" />;

  return (
    <Layout className="auth-page">
      <SEO title={t("auth")} />
      <Space className="auth-page-inner" size={12} direction="vertical">
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 8 }}>
          <BrandLogo size="large" linkToHome={false} />
        </div>
        <Title level={2} style={{ margin: 0 }}>{t("welcomeBack")}</Title>
        <Text className="auth-page-subtitle" type="secondary">
          {t("loginToContinue")}
        </Text>
        <div className="custom-card">
          <SignInForm />
        </div>
      </Space>
    </Layout>
  );
}
